export default __webpack_public_path__ + "static/media/squelch.d5330978.wav";